'use strict';exports.__esModule = true;exports.formatProjectOptions = exports.formatOptions = exports.formatTypes = exports.formatRooms = undefined;var _constants = require('../constants');
var _getLocalizedData = require('./getLocalizedData');var _getLocalizedData2 = _interopRequireDefault(_getLocalizedData);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var formatRooms = exports.formatRooms = function formatRooms(array, translate, isfullTitle) {
  var values = array.map(function (element) {return {
      value: typeof element.value === 'number' ? element.value.toString() : element.value,
      label: element.label };});


  values.unshift({
    label: '' + translate('searchContainer', isfullTitle ? 'all_rooms' : 'all'),
    value: 'all' });


  return values;
};

var formatTypes = exports.formatTypes = function formatTypes(types, translate, isfullTitle, optionType) {
  var filtered = (0, _constants.getFilteredPropertyTypes)(types, optionType);
  var values = filtered.map(function (element) {return {
      value: element,
      label: translate('propertyTypes', element) };});


  values.unshift({
    label: '' + translate('search_box', 'searchContainer', isfullTitle ? 'all_property_types' : 'all'),
    value: 'all' });


  return values;
};

var formatOptions = exports.formatOptions = function formatOptions(value, translate) {return {
    label: '' + translate('searchContainer', value),
    value: value,
    selected: false };};


var formatProjectOptions = exports.formatProjectOptions = function formatProjectOptions(locale, translate, isFullTitle) {
  var values = _constants.projectStatuses.map(function (item) {return {
      value: item.name,
      label: (0, _getLocalizedData2.default)(item.localisation, locale).result };});


  values.unshift({
    label: '' + translate('searchContainer', isFullTitle ? 'all_statuses' : 'all'),
    value: 'all' });


  return values;
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatSearchBoxData.js
// module id = 235
// module chunks = 0